
define('text!modules/reporting/segments/dataExport/createEdit/performance/templates/bins.html',[],function () { return '<div class="container" style="height:100%;">\n    <creatives-bin-list style="height:98%;" id="bl" fitparent unresolved header="SELECTED SEGMENTS: "></creatives-bin-list>\n</div>';});

